import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "overflow-hidden text-gray-700" }
const _hoisted_2 = { class: "container px-5 mx-auto" }
const _hoisted_3 = { class: "flex flex-wrap -m-1 md:-m-2" }
const _hoisted_4 = { class: "flex flex-wrap w-1/2" }
const _hoisted_5 = { class: "w-1/2 p-1 md:p-2" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "w-1/2 p-1 md:p-2" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "w-full p-1 md:p-2" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "flex flex-wrap w-1/2" }
const _hoisted_12 = { class: "w-full p-1 md:p-2" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "w-1/2 p-1 md:p-2" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "w-1/2 p-1 md:p-2" }
const _hoisted_17 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              alt: "gallery",
              class: "block object-cover object-center w-full h-full rounded-lg",
              src: require('../../assets/' + _ctx.pictures[0])
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              alt: "gallery",
              class: "block object-cover object-center w-full h-full rounded-lg",
              src: require('../../assets/' + _ctx.pictures[1])
            }, null, 8, _hoisted_8)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("img", {
              alt: "gallery",
              class: "block object-cover object-center w-full h-full rounded-lg",
              src: require('../../assets/' + _ctx.pictures[2])
            }, null, 8, _hoisted_10)
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("img", {
              alt: "gallery",
              class: "block object-cover object-center w-full h-full rounded-lg",
              src: require('../../assets/' + _ctx.pictures[3])
            }, null, 8, _hoisted_13)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("img", {
              alt: "gallery",
              class: "block object-cover object-center w-full h-full rounded-lg",
              src: require('../../assets/' + _ctx.pictures[4])
            }, null, 8, _hoisted_15)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("img", {
              alt: "gallery",
              class: "block object-cover object-center w-full h-full rounded-lg",
              src: require('../../assets/' + _ctx.pictures[5])
            }, null, 8, _hoisted_17)
          ])
        ])
      ])
    ])
  ]))
}